var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolei(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_392_4801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1412 31.9476C8.62115 31.9476 1.68115 25.0176 1.68115 16.4876C1.68115 7.95759 8.62115 1.02759 17.1412 1.02759C25.6612 1.02759 32.6012 7.96759 32.6012 16.4876C32.6012 25.0076 25.6612 31.9476 17.1412 31.9476ZM17.1412 2.89759C9.65115 2.89759 3.55115 8.99759 3.55115 16.4876C3.55115 23.9776 9.65115 30.0776 17.1412 30.0776C24.6312 30.0776 30.7312 23.9776 30.7312 16.4876C30.7312 8.99759 24.6312 2.89759 17.1412 2.89759Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3312 29.6577L22.4713 29.3877C22.5313 28.9977 23.7413 19.7677 16.5312 17.3977L17.1212 15.6177C20.7512 16.8177 23.1513 19.6477 24.0513 23.8077C24.7113 26.8577 24.3412 29.5377 24.3312 29.6477V29.6577Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3612 25.3977C7.3812 25.3977 4.7212 24.2677 4.5312 24.1777C4.0612 23.9677 3.8412 23.4177 4.0512 22.9477C4.2612 22.4777 4.8112 22.2577 5.2812 22.4677C5.3512 22.4977 12.7912 25.6277 21.3112 20.8377C21.7612 20.5877 22.3312 20.7477 22.5912 21.1977C22.8412 21.6477 22.6812 22.2177 22.2312 22.4777C18.1812 24.7577 14.3912 25.4077 11.3612 25.4077V25.3977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9612 17.1376C16.3412 13.3676 17.7512 9.92758 21.0312 7.20758C23.4312 5.20758 25.9812 4.30758 26.0912 4.26758L26.7112 6.03758C26.3412 6.16758 17.5912 9.34758 18.8112 16.8476L16.9612 17.1476V17.1376Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3511 25.1376C28.8611 25.1376 28.4511 24.7576 28.4211 24.2576C28.4211 24.1376 27.8111 16.3476 19.6511 11.0076C19.2211 10.7276 19.1011 10.1476 19.3811 9.7076C19.6611 9.2676 20.2411 9.1576 20.6811 9.4376C29.6811 15.3276 30.2711 23.7876 30.2911 24.1376C30.3211 24.6576 29.9311 25.0976 29.4111 25.1276C29.3911 25.1276 29.3711 25.1276 29.3511 25.1276V25.1376Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9411 18.8276C10.5911 18.8276 9.17107 18.5676 7.71107 18.0476C4.77107 17.0076 2.69107 15.2776 2.60107 15.1976L3.80107 13.7576C4.10107 14.0076 11.3011 19.9076 17.1211 15.0376L18.3211 16.4776C16.4611 18.0376 14.2911 18.8276 11.9311 18.8276H11.9411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.761 18.1975C10.761 18.1975 10.731 18.1975 10.721 18.1975C10.201 18.1775 9.80103 17.7375 9.82103 17.2175C10.281 6.47749 17.401 1.47749 17.701 1.26749C18.131 0.977485 18.711 1.08749 19.001 1.50749C19.291 1.93749 19.181 2.51749 18.761 2.80749C18.691 2.85749 12.121 7.51748 11.691 17.2875C11.671 17.7875 11.251 18.1875 10.751 18.1875L10.761 18.1975Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_392_4801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.92,
    height: 30.92,
    fill: "white",
    transform: "translate(1.68115 1.02759)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolei);
export default __webpack_public_path__ + "static/media/volei.39dbf85493b169191bddfcb5d40b1b81.svg";
export { ForwardRef as ReactComponent };